import { identity, pickBy } from 'lodash';

export const removeEmptyKeys = <T extends object>(object: T): Partial<T> =>
  pickBy(object, identity);
